/*
 * create by nguyendx 2017/09/26
 */
import {NgModule} from '@angular/core';
import {UploadService} from '../../../common/services/Upload.service';
import {EvsProductsModule} from './product/product.module';
import {ScanModule} from './scan/scan.module';
import {LogsModule} from './logs/log.module';
import {StampListModule} from './stamp_list/stamp.module';
import {StoreModule} from './store_manager/store.module';
import {ToastrModule} from 'ngx-toastr';
import {BsDatepickerModule} from 'ngx-bootstrap';
import {IdentifierModule} from './identifier/identifier.module';
import {BusinessContactService} from './business/business-contact/services/business-contact.service';

// @ts-ignore
// import {StatisticsDistributedComponent} from './src/app/pages/admin/evs/statistics-distributed/statistics-distributed.component';

@NgModule({
  imports: [
    EvsProductsModule,
    ScanModule,
    LogsModule,
    IdentifierModule,
    StampListModule,
    StoreModule,
    ToastrModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  declarations: [],
  exports: [],
  providers: [UploadService, BusinessContactService],
})
export class EvsProModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/evs_pro.module.ts